import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import React, { useState, useEffect } from 'react'
import Select from 'react-select'
// import TextEditor from '../../../feature-module/inventory/texteditor';
import { useToast } from '../../../Toaster/ToastContext';
import PropTypes from 'prop-types';
import { apiClient } from "../../../services/apiClient";

const AddPurchases = ({ currentPurchase, onClose, onUpdate }) => {
    const status = [
        { value: 'choose', label: 'Choose' },
        { value: 'received', label: 'Received' },
        { value: 'pending', label: 'Pending' },
    ];

    const [selectedDateModal, setSelectedDateModal] = useState(null);
    const [suppliers, setSuppliers] = useState([]);
    const [branches, setBranches] = useState([]);
    const [allProducts, setAllProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [referenceNo, setReferenceNo] = useState('');
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [notes, setNotes] = useState('');
    const { showToast } = useToast();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [suppliersData, branchesData, productsData] = await Promise.all([
                    apiClient.get('/get-all-supplier'),
                    apiClient.get('/get-all-branch'),
                    apiClient.post('/get-all-products'),
                ]);

                const supplierOptions = [
                    { value: 'choose', label: 'Choose Supplier' },
                    ...suppliersData.data.map(supplier => ({
                        value: supplier.id,
                        label: supplier.supplier_name
                    }))
                ];
                setSuppliers(supplierOptions);

                const branchOptions = [
                    { value: 'choose', label: 'Choose Branch' },
                    ...branchesData.data.map(branch => ({
                        value: branch.id,
                        label: branch.name
                    }))
                ];
                setBranches(branchOptions);

                const productOptions = productsData.data || [];
                setAllProducts(productOptions);
                if (currentPurchase) {
                setSelectedSupplier(supplierOptions.find(s => s.value === currentPurchase.supplier_id));
                setSelectedBranch(branchOptions.find(b => b.value === currentPurchase.branch_id));
                setSelectedDateModal(currentPurchase.date ? new Date(currentPurchase.date) : null);
                setReferenceNo(currentPurchase.reference || '');
                setSelectedStatus(status.find(s => s.value === currentPurchase.status) || null);
                setNotes(currentPurchase.note || '');
                // Map items to tableData
                setTableData(currentPurchase.items.map(item => ({
                    productId: item.product_id,
                    product: allProducts.find(p => p.id === item.product_id)?.name || 'Unknown Product',
                    qty: item.quantity,
                    purchasePrice: parseFloat(item.price),
                    unitCost: parseFloat(item.price),
                    totalCost: parseFloat(item.subtotal),
                    variants: []
                })));
            }

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [currentPurchase]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const totalAmount = tableData.reduce((sum, item) => {
            if (item.variants && item.variants.length > 0) {
                return sum + item.variants.reduce((vSum, v) => vSum + (v.totalCost || 0), 0);
            }
            return sum + (item.totalCost || 0);
        }, 0);

        const purchaseData = {
            ...(currentPurchase?.id && { id: currentPurchase.id }),
            supplier_id: selectedSupplier?.value || null,
            branch_id: selectedBranch?.value || null,
            purchase_date: selectedDateModal ? selectedDateModal.toISOString().split('T')[0] : null,
            reference_no: referenceNo || '',
            status: selectedStatus?.value || null,
            notes: notes || '',
            method: 'cash',
            total_amount: totalAmount || 0,
            products: tableData.map(item => ({
                product_id: item.productId,
                ...(item.variants && item.variants.length > 0 ? {
                    variants: item.variants.map(v => ({
                        variant_id: v.id,
                        quantity: v.qty || 0,
                        purchase_price: v.purchasePrice || 0,
                        unit_cost: v.unitCost || 0,
                        total_cost: v.totalCost || 0
                    }))
                } : {
                    quantity: item.qty || 0,
                    purchase_price: item.purchasePrice || 0,
                    unit_cost: item.unitCost || 0,
                    total_cost: item.totalCost || 0
                })
            }))
        };

        try {
            const response = await apiClient.post('/store-update-purchase', purchaseData);
            if (response.status) {
                // Reset form
                setSelectedBranch(null);
                setSelectedProduct(null);
                setTableData([]);
                setSelectedSupplier(null);
                setReferenceNo("");
                setSelectedStatus(null);
                setNotes("");
                setSelectedDateModal(null);
                
                document.querySelector('[data-bs-dismiss="modal"]').click();
                if (onClose) onClose();
                if (onUpdate) onUpdate();
                showToast(`Purchase ${currentPurchase ? 'updated' : 'added'} successfully.`, 'success', 'Purchase Operation!');
            }
        } catch (error) {
            console.error('Error submitting purchase:', error);
            showToast(error.message || `Failed to ${currentPurchase ? 'update' : 'add'} purchase`, 'error', 'Purchase Operation!');
        }
    };

    AddPurchases.propTypes = {
        currentPurchase: PropTypes.shape({
            id: PropTypes.number,
            supplier_id: PropTypes.number,
            branch_id: PropTypes.number,
            date: PropTypes.string, 
            reference: PropTypes.string,
            status: PropTypes.string,
            note: PropTypes.string,
            items: PropTypes.arrayOf(PropTypes.shape({
                id: PropTypes.number,
                product_id: PropTypes.number,
                quantity: PropTypes.number,
                price: PropTypes.string,
                subtotal: PropTypes.string
            })),
            products: PropTypes.arrayOf(PropTypes.shape({
                product_id: PropTypes.number,
                product_name: PropTypes.string,
                quantity: PropTypes.number,
                purchase_price: PropTypes.number,
                unit_cost: PropTypes.number,
                total_cost: PropTypes.number,
                variants: PropTypes.arrayOf(PropTypes.shape({
                    variant_id: PropTypes.number,
                    variant_name: PropTypes.string,
                    variant_value: PropTypes.string,
                    quantity: PropTypes.number,
                    purchase_price: PropTypes.number,
                    unit_cost: PropTypes.number,
                    total_cost: PropTypes.number
                }))
            }))
        }),
        onClose: PropTypes.func,
        onUpdate: PropTypes.func
    };

    const handleDateChangeModal = (date) => {
        setSelectedDateModal(date);
    };

    const handleBranchChange = (selected) => {
        setSelectedBranch(selected);
        setSelectedProduct(null);
        setTableData([]);

        if (selected && selected.value !== 'choose') {
            const branchProducts = allProducts
                .filter(product => product.branch_id == selected.value)
                .map(product => ({
                    value: product.id,
                    label: product.name,
                    price: product.price || 0,
                    variants: product.variants || []
                }));
            setFilteredProducts(branchProducts);
        } else {
            setFilteredProducts([]);
        }
    };

    const handleProductChange = (selected) => {
        setSelectedProduct(selected);
        if (selected && selected.value !== 'choose') {
            const productExists = tableData.some(item => item.productId === selected.value);
            if (!productExists) {
                const product = allProducts.find(p => p.id === selected.value);
                const price = parseFloat(product.price) || '';
                if (product.variants && product.variants.length > 0) {
                    const newProduct = {
                        productId: selected.value,
                        product: selected.label,
                        variants: product.variants.map(variant => {
                            const variantPrice = parseFloat(variant.price) || ''; // Convert variant price to number
                            return {
                                id: variant.id,
                                name: variant.name,
                                variantValue: variant.variant_value,
                                qty: variant.quantity || 1,
                                purchasePrice: variantPrice,
                                unitCost: variantPrice,
                                totalCost: variantPrice * (variant.quantity || 1)
                            };
                        })
                    };
                    const updatedTableData = [...tableData, newProduct];
                    setTableData(updatedTableData);
                } else {
                    const newProduct = {
                        productId: selected.value,
                        product: selected.label,
                        qty: 1,
                        purchasePrice: price,
                        unitCost: price,
                        totalCost: price * 1
                    };
                    const updatedTableData = [...tableData, newProduct];
                    setTableData(updatedTableData);
                }
            }
        }
        setSelectedProduct(null);
    };

    const handleTableInputChange = (productIndex, variantIndex, field, value) => {
        const updatedData = [...tableData];
        if (!updatedData[productIndex]) {
            console.error(`Invalid productIndex: ${productIndex}`);
            return; 
        }

        let item;
        if (updatedData[productIndex].variants && updatedData[productIndex].variants.length > 0) {
            if (!updatedData[productIndex].variants[variantIndex]) {
                console.error(`Invalid variantIndex: ${variantIndex} for productIndex: ${productIndex}`);
                return; 
            }
            item = updatedData[productIndex].variants[variantIndex];
        } else {
            item = updatedData[productIndex];
        }

        item[field] = value === '' ? null : (field === 'qty' ? parseInt(value) || 0 : parseFloat(value) || 0);
        item.unitCost = item.purchasePrice !== null ? item.purchasePrice : 0;
        item.totalCost = (item.qty !== null ? item.qty : 0) * (item.unitCost !== null ? item.unitCost : 0);

        setTableData(updatedData);
    };

    const handleRemoveProduct = (index) => {
        const updatedData = tableData.filter((_, i) => i !== index);
        setTableData(updatedData);
    };

    return (
        <div>
            {/* Add Purchase */}
            <div className="modal fade" id="add-units">
                <div className="modal-dialog purchase modal-dialog-centered stock-adjust-modal">
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0">
                            <div className="content">
                                <div className="modal-header border-0 custom-modal-header">
                                    <div className="page-title">
                                        <h4>Add Purchase</h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body custom-modal-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-4 col-md-6 col-sm-12">
                                                <div className="input-blocks">
                                                    <label>Supplier Name</label>
                                                    <Select 
                                                        options={suppliers} 
                                                        className="select" 
                                                        placeholder="Choose Supplier"
                                                        value={selectedSupplier}
                                                        onChange={(selected) => setSelectedSupplier(selected)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-6 col-sm-12">
                                                <div className="input-blocks">
                                                    <label>Branch Name</label>
                                                    <Select 
                                                        options={branches} 
                                                        className="select" 
                                                        placeholder="Choose Branch"
                                                        value={selectedBranch}
                                                        onChange={handleBranchChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-6 col-sm-12">
                                                <div className="input-blocks">
                                                    <label>Product Name</label>
                                                    <Select 
                                                        options={filteredProducts} 
                                                        className="select" 
                                                        placeholder="Choose Product"
                                                        onChange={handleProductChange}
                                                        value={selectedProduct}
                                                        isDisabled={!selectedBranch}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-6 col-sm-12">
                                                <div className="input-blocks">
                                                    <label>Purchase Date</label>
                                                    <div className="input-group date-group">
                                                        <span className="input-group-text">
                                                            <i className="bi bi-calendar-date"></i>
                                                        </span>
                                                        <DatePicker
                                                            selected={selectedDateModal}
                                                            onChange={handleDateChangeModal}
                                                            dateFormat="dd/MM/yyyy"
                                                            placeholderText="Choose Date"
                                                            className="form-control datetimepicker"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-6 col-sm-12">
                                                <div className="input-blocks">
                                                    <label>Reference No</label>
                                                    <input 
                                                        type="text" 
                                                        className="form-control"
                                                        value={referenceNo}
                                                        onChange={(e) => setReferenceNo(e.target.value)} 
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-6 col-sm-12">
                                                <div className="input-blocks">
                                                    <label>Status</label>
                                                    <Select 
                                                        options={status} 
                                                        className="select" 
                                                        placeholder="Choose"
                                                        value={selectedStatus}
                                                        onChange={(selected) => setSelectedStatus(selected)} 
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            {tableData.length > 0 && (
                                                <div className="col-lg-12">
                                                    <div className="modal-body-table">
                                                        <div className="table-responsive">
                                                            <table className="table datanew">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Product</th>
                                                                        <th>Variant</th>
                                                                        <th>Qty</th>
                                                                        <th>Purchase Price($)</th>
                                                                        <th>Unit Cost($)</th>
                                                                        <th>Total Cost($)</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {tableData.map((item, productIndex) => (
                                                                        item.variants && item.variants.length > 0 ? (
                                                                            item.variants.map((variant, variantIndex) => (
                                                                                <tr key={`${productIndex}-${variantIndex}`}>
                                                                                    {variantIndex === 0 && (
                                                                                        <td rowSpan={item.variants.length}>{item.product}</td>
                                                                                    )}
                                                                                    <td>{variant.name} ({variant.variantValue})</td>
                                                                                    <td>
                                                                                        <input type="number" className="form-control"
                                                                                            value={variant.qty === null ? '' : variant.qty} min="1"
                                                                                            onChange={(e) => handleTableInputChange(productIndex, variantIndex, 'qty', e.target.value)}
                                                                                        />
                                                                                    </td>
                                                                                    <td>
                                                                                        <input type="number" className="form-control"
                                                                                            value={variant.purchasePrice === null ? '' : variant.purchasePrice}
                                                                                            onChange={(e) => handleTableInputChange(productIndex, variantIndex, 'purchasePrice', e.target.value)}
                                                                                            min="0" step="0.01"
                                                                                        />
                                                                                    </td>
                                                                                    <td>{typeof variant.unitCost === 'number' ? variant.unitCost.toFixed(2) : '0.00'}</td>
                                                                                    <td>{typeof variant.totalCost === 'number' ? variant.totalCost.toFixed(2) : '0.00'}</td>
                                                                                    <td>
                                                                                        {variantIndex === 0 && (
                                                                                            <button 
                                                                                                className="btn btn-danger btn-sm"
                                                                                                onClick={() => handleRemoveProduct(productIndex)}
                                                                                            >
                                                                                                <i className="bi bi-trash"></i>
                                                                                            </button>
                                                                                        )}
                                                                                    </td>
                                                                                </tr>
                                                                            ))
                                                                        ) : (
                                                                            <tr key={productIndex}>
                                                                                <td>{item.product}</td>
                                                                                <td>-</td>
                                                                                <td>
                                                                                    <input type="number" className="form-control"
                                                                                        value={item.qty === null ? '' : item.qty} min="1"
                                                                                        onChange={(e) => handleTableInputChange(productIndex, 0, 'qty', e.target.value)}
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input type="number" className="form-control"
                                                                                        value={item.purchasePrice === null ? '' : item.purchasePrice}
                                                                                        onChange={(e) => handleTableInputChange(productIndex, 0, 'purchasePrice', e.target.value)}
                                                                                        min="0" step="0.01"
                                                                                    />
                                                                                </td>
                                                                                <td>{typeof item.unitCost === 'number' ? item.unitCost.toFixed(2) : '0.00'}</td>
                                                                                <td>{typeof item.totalCost === 'number' ? item.totalCost.toFixed(2) : '0.00'}</td>
                                                                                <td>
                                                                                    <button 
                                                                                        className="btn btn-danger btn-sm"
                                                                                        onClick={() => handleRemoveProduct(productIndex)}
                                                                                    >
                                                                                        <i className="bi bi-trash"></i>
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            
                                            {/* <div className="row">
                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                    <div className="input-blocks">
                                                        <label>Order Tax</label>
                                                        <input type="text" defaultValue={0} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                    <div className="input-blocks">
                                                        <label>Discount</label>
                                                        <input type="text" defaultValue={0} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                    <div className="input-blocks">
                                                        <label>Shipping</label>
                                                        <input type="text" defaultValue={0} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                    <div className="input-blocks">
                                                        <label>Status</label>
                                                        <Select options={status} className="select" placeholder="Choose" />
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="edit-add card">
                                                <div className="edit-add">
                                                    <label className="form-label">Description</label>
                                                </div>
                                                <div className="card-body-list input-blocks mb-0">
                                                    <textarea
                                                        className="form-control"
                                                        name="note"
                                                        value={notes}
                                                        onChange={(e) => setNotes(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            {/* <div className="input-blocks summer-description-box">
                                                <label>Notes</label>
                                                <div id="summernote" />
                                                <TextEditor value={notes} onChange={setNotes} />
                                            </div> */}
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="modal-footer-btn">
                                                <button
                                                    type="button"
                                                    className="btn btn-cancel me-2"
                                                    data-bs-dismiss="modal"
                                                >
                                                    Cancel
                                                </button>
                                                <button type="submit" className="btn btn-submit">
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddPurchases;
